var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import cart from '../helpers/cart';
import { docReady } from '../helpers/docReady';
import EmblaCarousel from 'embla-carousel';
docReady(function () {
    var productTemplate = document.querySelectorAll('#section-product, #section-product_default-merch');
    var scrollToForm = document.querySelector('[data-notify-bis]');
    productTemplate.forEach(function (template) {
        var events = ['load', 'resize'];
        var inputFields = template.querySelectorAll('.product-variant.selector-wrapper');
        inputFields.forEach(function (input) {
            events.forEach(function (event) {
                window.addEventListener(event, function () {
                    var inputField = input.querySelector('.regular-select-cover');
                    var inputHeight = inputField.offsetHeight;
                    var dropdown = input.querySelector('.product-variant.selector-wrapper .regular-select-content');
                    dropdown.style.top = "".concat(inputHeight, "px");
                });
            });
        });
        var radioFields = template.querySelectorAll('.product-variant.colour-selector');
        radioFields.forEach(function (field) {
            var firstColourSelector = field.querySelector('input[type="radio"]');
            var colourNameContainer = field.querySelector('p span.selected-colour-name');
            firstColourSelector.setAttribute('checked', '');
            colourNameContainer.innerHTML = firstColourSelector.getAttribute('value');
            var colourSelector = field.querySelectorAll('input[type="radio"]');
            colourSelector.forEach(function (colour) {
                colour.addEventListener('click', function (e) {
                    var selectedColour = e.target;
                    var colourName = selectedColour.getAttribute('value');
                    colourNameContainer.innerHTML = colourName;
                });
            });
        });
        var scrollButton = template.querySelector('.anchor__button');
        if (scrollButton) {
            scrollButton.addEventListener('click', function (e) {
                e.preventDefault();
                document.querySelector('#product-more-images').scrollIntoView({
                    behavior: 'smooth',
                });
            });
        }
    });
    if (scrollToForm) {
        var newsletter_1 = document.querySelector('#section-home_newsletter');
        scrollToForm.addEventListener('click', function (e) {
            e.preventDefault();
            if (newsletter_1) {
                newsletter_1.scrollIntoView({
                    behavior: 'smooth',
                });
            }
        });
    }
    // Add on carousel
    var addOnCarousels = document.querySelectorAll('.embla');
    if (addOnCarousels) {
        addOnCarousels.forEach(function (addOnCarousel) {
            var viewportNode = addOnCarousel.querySelector('.embla__viewport');
            var prevButtonNode = addOnCarousel.querySelector('.embla__prev');
            var nextButtonNode = addOnCarousel.querySelector('.embla__next');
            var options = { loop: true, startIndex: 1 };
            var embla = EmblaCarousel(viewportNode, options);
            prevButtonNode.addEventListener('click', function () { return embla.scrollPrev(); }, false);
            nextButtonNode.addEventListener('click', function () { return embla.scrollNext(); }, false);
            var addToCartBtns = addOnCarousel.querySelectorAll('[data-mt-add-to-cart]');
            if (addToCartBtns) {
                addToCartBtns.forEach(function (btn) {
                    var variantID = btn.dataset.mtAddToCart;
                    btn.addEventListener('click', function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, cart.add({ id: variantID, quantity: 1 }, btn)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                });
            }
        });
    }
    window.addEventListener('mtdt-cart-updated', function (e) {
        var cartBubble = document.querySelector('.count');
        cartBubble.innerText = e.detail.count;
    });
});
